var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBank = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.3725C0 6.14287 0.125429 5.93158 0.327019 5.82163L11 0L21.673 5.82163C21.8746 5.93158 22 6.14287 22 6.3725C22 6.71906 21.7191 7 21.3725 7H21V19L21.9146 20.8292C21.9708 20.9415 22 21.0654 22 21.191C22 21.6378 21.6378 22 21.191 22H0.809017C0.362209 22 0 21.6378 0 21.191C0 21.0654 0.029242 20.9415 0.0854102 20.8292L1 19V7H0.627497C0.28094 7 0 6.71906 0 6.3725Z",
    fill: "url(#paint0_linear_1827_55321)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7,
    width: 20,
    height: 12,
    fill: "url(#paint1_linear_1827_55321)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 2,
    height: 12,
    fill: "#E5E4EC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7,
    width: 2,
    height: 12,
    fill: "#E5E4EC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 7,
    width: 2,
    height: 12,
    fill: "#E5E4EC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 2,
    height: 1,
    fill: "#968FB8",
    fillOpacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 2,
    height: 1,
    fill: "#968FB8",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 9,
    width: 3,
    height: 1,
    fill: "#968FB8",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1827_55321",
    x1: 1.5,
    y1: 2,
    x2: 18.1018,
    y2: 24.8342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#928BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791273,
    stopColor: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1827_55321",
    x1: 1,
    y1: 7,
    x2: 8.26561,
    y2: 24.3368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D76A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#968FB8",
    stopOpacity: 0.6
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bank.1bbcefdcfc746b8b816c16d2eb9ed99d.svg";